module.exports = __webpack_public_path__ + "img/brush.0c0842d4acf03748ba2cb6957c9c2d1a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/brush.png
// module id = 69
// module chunks = 1